/**
 * https://github.com/zurb/responsive-tables
 * Skrypt przerobiony w znacznej części - dodana obługa rowspanów w 1 kolumnie
 * i nawigacja ( kroki )
 */

var $ = require('jquery');
var switched = false;

var updateTables = function () {
  if (($(window).width() < 767) && switched) {
    removeScrollableTableNavi();
    $('table.responsive').each(function () {
      var $wrapper = $(this).closest('.table-wrapper');

      setScrollableTableNavi($wrapper);
      $wrapper.find('.scrollable')[0].scrollLeft = 0;
    });

  } else {
    if (($(window).width() < 767) && !switched) {
      $('table').addClass('responsive');
      switched = true;
      $('table.responsive').each(function (i, element) {
        setScrollableTableNavi(splitTable($(element)));
      });
      return true;
    } else if (switched && ($(window).width() > 767)) {
      switched = false;
      $('table.responsive').each(function (i, element) {
        unsplitTable($(element));
        removeScrollableTableNavi();
      });
      $('table').removeClass('responsive').css('width', 'auto');
      ;
    }
  }
  setResponsiveTableWidth();
};

function setResponsiveTableWidth() {
  var $responsiveTable = $('.scrollable table.responsive');
  if ($responsiveTable.length) {
    var tableColumns = $responsiveTable.find('tr').first().find('td').length - 1;
    var responsiveTableWidth = tableColumns * 100;
    var responsiveTableItemWidth = 100 / tableColumns;
    $responsiveTable.css('width', responsiveTableWidth + '%');
    $responsiveTable.find('td, th').each(function(index) {
      $(this).css('width', responsiveTableItemWidth + '%');
    });
  } else {
    $responsiveTable.find('td, th').each(function(index) {
      $(this).css('width', 'auto');
    });
  }
}

function removeScrollableTableNavi() {
  $('.table__navi').remove();
}

function calculateColsOffsets($scrollable) {
  var $rows = $scrollable.find('tr'),
    scrollableWidth = $scrollable.width(),
    vertMod = [],
    colsOffsets = [],
    newOffsets = [0];

  $rows.each(function (rowIdx) {
    var $row = $(this),
      horzMod = 0;

    vertMod[rowIdx] = [];

    $row.find('td:visible, th:visible').each(function (i) {
      var $cell = $(this),
        posLeft = $cell.position().left;

      if (!colsOffsets[i + horzMod]) {
        colsOffsets[i + horzMod] = posLeft;
      }

      horzMod += (parseInt($cell.attr('colspan')) - 1 || 0);

      if (rowIdx > 0 && vertMod[rowIdx - 1][i] > 0) {
        horzMod += 1;
        vertMod[rowIdx - 1][i] -= 1;
      }

      vertMod[rowIdx][i + horzMod] = (parseInt($cell.attr('rowspan')) - 1 || 0);
    });
  });

// Usuwam zbędne offset, tj. takie, które leża w obrębie 1 "strony"
// tabeli ( na podstawie szerokości table.scrollable )
  var stepIdx = 1;
  colsOffsets.forEach(function (offset, i) {
    if (!newOffsets[stepIdx] && offset + 20 >= (scrollableWidth * stepIdx)) {
      newOffsets[stepIdx++] = colsOffsets[i];
    }
  });

  return newOffsets;
}

function setScrollableTableNavi($wrapper) {
  var $scrollable = $wrapper.find('.scrollable'),
    $responsive = $wrapper.find('.responsive'),
    scrollTimeout,
    current = 0;

  if ($responsive.width() > $scrollable.width()) {
    var colsOffsets = calculateColsOffsets($scrollable, colsOffsets);

    if (colsOffsets.length <= 1) return;

    var $tableNavi = $('<div class="table__navi"></div>'),
      $btnPrev = $('<span class="table__navi__prev"><svg role="img" title="arrow-left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/static/dist-tracked/front/iko-app-lite/symbol/svg/sprite.symbol.svg#arrow_left"></use></svg></span>'),
      $btnNext = $('<span class="table__navi__next"><svg role="img" title="arrow-right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/static/dist-tracked/front/iko-app-lite/symbol/svg/sprite.symbol.svg#arrow_right"></use></svg></span>'),
      $totalSteps = $('<span class="table__navi__total"></span>'),
      $separator = $('<span class="table__navi__separator">/</span>'),
      $currentStep = $('<span class="table__navi__current">1</span>'),
      $precedingHeaders = $wrapper.prev('h2, h3, h4');


    // eventy
    $btnPrev.off().on('click', function () {
      if (current - 1 >= 0 && !$scrollable.is(':animated')) {
        $scrollable.animate({
          scrollLeft: colsOffsets[current - 1]
        });
      }
    });

    $btnNext.off().on('click', function () {
      if (current + 1 < colsOffsets.length && !$scrollable.is(':animated')) {
        $scrollable.animate({
          scrollLeft: colsOffsets[current + 1]
        });
      }
    });

    $scrollable.off().on('scroll', function () {
      clearTimeout(scrollTimeout);

      scrollTimeout = setTimeout(function () {
        var pos = this.scrollLeft;

        colsOffsets.forEach(function (offset, i) {
          if (pos >= offset) {
            current = i;
            $currentStep.text(current + 1);
          }
        });

        // ustawiam ostatni aktywny z razie gdyby offset nie został
        // osiągnięty ( wąska ostatnia kolumna )
        if ($(this).scrollLeft() + $(this).width() >= $responsive.width() - 5) {
          current = colsOffsets.length - 1;
          $currentStep.text(current + 1);
        }

      }.bind(this), 100);
    });

    // html
    $tableNavi
      .append($btnPrev)
      .append($currentStep)
      .append($separator)
      .append($totalSteps)
      .append($btnNext);

    if ($precedingHeaders.length) {
      $precedingHeaders.addClass('clearfix').append($tableNavi);
    } else {
      $wrapper.prepend($tableNavi);
    }

    $totalSteps.text(colsOffsets.length);
  }
}

function splitTable(original) {
  original.wrap('<div class="table-wrapper" />');

  var copy = original.clone();
  var rowspansHolder = 0;
  var fullRowsInOriginalIndexes = [];
  var $originalRows = original.find('tr');

  copy.find('tr').each(function (i) {
    var $row = $(this),
      rowspan = $row.find('td, th').first().attr('rowspan') || 1,
      $cells = $row.find('td, th'),
      sliceStart = 1;

    if (rowspansHolder > 0) {
      sliceStart = 0;
      rowspansHolder--;
      fullRowsInOriginalIndexes.push(i);
    }

    $cells.slice(sliceStart).css('display', 'none');
    rowspansHolder += rowspan - 1;
  });

  fullRowsInOriginalIndexes.forEach(function (el) {
    $originalRows.eq(el).find('td, th').first().css('display', 'table-cell');
  });

  copy.removeClass('responsive');

  var $wrapper = original.closest('.table-wrapper');
  $wrapper.append(copy);
  copy.wrap('<div class="pinned" />');
  original.wrap('<div class="scrollable" />');

  setCellHeights(copy, original);
  return $wrapper;
}

function unsplitTable(original) {
  original.closest('.table-wrapper').find('.pinned').remove();
  original.unwrap();
  original.unwrap();
}

function setCellHeights(original, copy) {
  //$('table.responsive').css('width', '300%');

  var tr = original.find('tr'),
    tr_copy = copy.find('tr'),
    heights = [];

  tr.each(function (index) {
    var self = $(this),
      tx = self.find('th, td');
    tx.each(function () {
      if ($(this).attr('rowspan')) return;
      var height = $(this).outerHeight(true);
      heights[index] = heights[index] || 0;
      if (height > heights[index]) heights[index] = height;
    });
  });

  tr_copy.each(function (index) {
    this.style.height = (heights[index]) + 'px';
  });

  tr.each(function (index) {
    this.style.height = (heights[index]) + 'px';
  });
}

function init() {
  //$(window).load(updateTables);
  $(window).on('redraw', function () {
    switched = false;
    updateTables();
  }); // An event to listen for
}

module.exports = {
  init: init,
  resize: updateTables
};



//////////////////
// WEBPACK FOOTER
// ./front/iko-app-lite/js/vendor/responsive-table.js
// module id = 351
// module chunks = 0